module.exports = __webpack_public_path__ + "static/media/waves.10c32f43.svg";